import React from 'react'

import Translator from 'bazinga-translator'
import Button from 'components/Btn'

import { ConfirmDialogProps } from '../types'

export const ConfirmDialogButtons = ({
  acceptButtonLabel,
  refuseButtonLabel,
  acceptButtonClassName,
  refuseButtonClassName,
  onAccept,
  onRefuse,
  variant = 'default',
}: ConfirmDialogProps) => {
  const buttonProps = { [variant]: true }

  const acceptButton = acceptButtonLabel ?? Translator.trans('yes')
  const refuseButton = refuseButtonLabel ?? Translator.trans('no')

  return (
    <>
      <Button
        onClick={onRefuse}
        className={refuseButtonClassName}
        outlined
        md
      >
        {refuseButton}
      </Button>
      <Button
        {...buttonProps}
        className={acceptButtonClassName}
        onClick={onAccept}
        md
      >
        {acceptButton}
      </Button>
    </>
  )
}
